<template>
  <v-radio-group v-model="radios" :mandatory="true">
    <v-radio :disabled="isValid"
             :label="titleAndCosts" :value="keyword">
    </v-radio>
  </v-radio-group>
</template>

<script>
// import Vue from 'vue';
import moment from 'moment';
import 'moment/min/locales';

export default {
  name: 'event-component-item',
  data() {
    return {
      radios: null,
    };
  },
  props: {
    title: {
      type: String,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    age: {
      type: Number,
    },
    keyword: {
      type: String,
    },
    cost: {
      type: Number,
    },
    discountMultipleDogs: {
      type: Boolean,
    },
  },
  watch: {
    menu(val) {
      return val && this.$nextTick(() => {
        this.$refs.picker.activePicker = 'YEAR';
      });
    },
  },
  computed: {
    isValid() {
      return true;
    },
    difference() {
      return moment(this.daydate).diff(this.date, 'months', true);
    },
    titleAndCosts() {
      return `${this.title} €${this.cost / 100}`;
    },
  },
  methods: {
    between(a, b) {
      return this.difference >= a && this.difference <= b;
    },
    olderThan(a) {
      return this.difference >= a;
    },
    save(date) {
      this.$refs.menu.save(date);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/EventComponentItem.vue